import { UserComponent } from '@craftjs/core';
import { BaseControlSettings, defaultToolSettings } from '../inputs/base/baseControlSettings';
import { createId } from 'src/helpers/typeUtils';
import { IContainerProps } from '../containers/Container';

export const DIFFERENCE_UNITS = ['years', 'months', 'weeks', 'days'] as const;

export type DifferenceType = (typeof DIFFERENCE_UNITS)[number];

export interface IDateIntervalCalcProps extends BaseControlSettings, IContainerProps {
  dataKey: string;
  differenceUnits: DifferenceType;
}

export type IDateIntervalCalc = UserComponent<IDateIntervalCalcProps>;

export function dateIntervalCalcDefaultPropsFactory(): IDateIntervalCalcProps {
  return {
    ...defaultToolSettings,
    differenceUnits: 'days',
    dataKey: createId(),
  };
}
